<vex-table *ngIf="params"
  [params] = "params"
  (event) = "receiveType($event)">
</vex-table>
